// "2 accounts" / "1 of 3 accounts connected", with the accounts on hover (owner 2026-10-25:
// the personal area lists all the accounts connected, each project card and each project
// page the number of accounts per Procore and per ACC).
//
// `list`: [{ label, email?, connected }] - the personal area's /procore/status and
// /acc/status `accounts`, or a project's GET /integrations `accounts.<provider>.list`.
import React from "react";
import { Popover } from "antd";
import "./integrations.scss";

export function accountsText(list) {
  const all = Array.isArray(list) ? list : [];
  const on = all.filter((a) => a.connected).length;
  if (!all.length) return "no accounts";
  const n = `${all.length} account${all.length === 1 ? "" : "s"}`;
  return on === all.length ? `${n} connected` : `${on} of ${n} connected`;
}

export default function AccountsCount({ list, name, testId }) {
  const all = Array.isArray(list) ? list : [];
  const broken = all.some((a) => !a.connected);
  const content = all.length ? (
    <div className="accounts-count-list">
      {all.map((a, i) => (
        <div key={a.id || a.key || i} className="accounts-count-row">
          <span className={`accounts-count-dot ${a.connected ? "on" : "off"}`} />
          <span>{a.label || a.email || `${name || ""} account`}</span>
          {a.email && a.email !== a.label ? <small className="text-muted">{a.email}</small> : null}
          <small className={a.connected ? "text-success" : "text-danger"}>{a.connected ? "Connected" : "Not connected"}</small>
        </div>
      ))}
    </div>
  ) : (
    <span className="text-muted">No {name || ""} account yet</span>
  );
  return (
    <Popover title={name ? `${name} accounts` : "Accounts"} content={content}>
      <span className={`accounts-count ${broken ? "broken" : ""}`} data-testid={testId}>
        {accountsText(all)}
      </span>
    </Popover>
  );
}

/**
 * The accounts a project page shows for one provider, from GET /integrations/:projectId:
 * the ones the project's destinations use; a project with none yet shows the accounts the
 * viewer could use (`connections`).
 */
export function projectAccounts(data, provider) {
  const used = data && data.accounts && data.accounts[provider];
  if (used && used.list && used.list.length) return used.list;
  return (data && data.connections && data.connections[provider]) || [];
}

/**
 * Whether one destination's account works: its own account (the actor's connection) when
 * the server names it, else any account the viewer has for the provider.
 */
export function destinationConnected(data, provider, d) {
  if (d && d.actor) return !!d.actor.connected;
  const p = (data && data[provider]) || {};
  return !!p.connected || ((data && data.connections && data.connections[provider]) || []).some((a) => a.connected);
}

/** The per-provider counts at the head of a project page's Procore / ACC bar. */
export function ProviderAccounts({ data }) {
  return (
    <span className="provider-accounts">
      {[["procore", "Procore"], ["acc", "ACC"]].map(([key, name]) => (
        <span key={key} className="provider-accounts-one">
          {name}: <AccountsCount list={projectAccounts(data, key)} name={name} testId={`project-accounts-${key}`} />
        </span>
      ))}
    </span>
  );
}
